import { analyticsController } from 'src/modules/user/analytics/AnalyticsController';
import { userService } from 'src/modules/user/UserService';
import { introJsService } from "src/modules/onboarding/intro/IntroJsService";
import { openSubscribePage } from "src/utils/NavigationUtils";
import { schoolService } from '../modules/school/SchoolService'
import { challengeService } from '../modules/playable/ChallengeService';

export default ({ router, Vue }) => {
  // Require Auth
  router.beforeEach((to, from, next) => {
    document.title =
      typeof to.meta.title === 'function' ? to.meta.title(to) + ' | Tokatab' : to.meta.title + ' | Tokatab';

    to.matched.some((record) => {
      if ('meta' in record) {
        if ('requiresAuth' in record.meta && record.meta.requiresAuth) {
          if (!localStorage.tokenTokatab) {
            next({
              path: '/login',
              query: { redirect: to.fullPath },
            });
          }
          else {
            next();
          }
        }
        else {
          next();
        }
      }
    });
  });

  // Premium Check
  router.beforeEach(async (to, from, next) => {
    const premiumCheck = async (to, from, next) => {
      if(to.name === 'ImportMusicxmlPiece') {
        if(userService.user.importedPieceIds.length >= 1 && !userService.user.premium) {
          openSubscribePage(from.path, undefined, from.fullPath)
          return
        }
        next()
      }

      if (to.name === 'Leçon') {
        await schoolService.loadModule(parseInt(to.params.moduleId), true)
        schoolService.state.activeModule.isFree || userService.user.premium || (userService.user.configurations.currentWeeklyFreeActions > 0 && userService.user.configurations.currentDailyFreeActions > 0) ? next() : openSubscribePage(from.path, undefined, from.fullPath)
      }
      else if (to.name === 'Player School') {
        userService.user.premium || (userService.user.configurations.currentWeeklyFreeActions > 0 && userService.user.configurations.currentDailyFreeActions > 0) ? next() : openSubscribePage(from.path, undefined, from.fullPath)
      }
      else if (to.name === 'Player Challenge') {
        await challengeService.loadChallenge(parseInt(to.params.playableId), true)
        challengeService.state.currentChallenge.baseModel.is_free || userService.user.premium || (userService.user.configurations.currentWeeklyFreeActions > 0 && userService.user.configurations.currentDailyFreeActions > 0) ? next() : openSubscribePage(from.path, undefined, from.fullPath)
      }
      else {
        userService.user.premium || (userService.user.configurations.currentWeeklyFreeActions > 0 && userService.user.configurations.currentDailyFreeActions > 0) ? next() : openSubscribePage(from.path, undefined, '/home')
      }
    }

    if (to.matched.some((record) => record.meta.isPremium)) {
      if (userService.user.id === 0) {
        userService.once('userService_loaded', () => premiumCheck(to, from, next))
      }
      else {
        premiumCheck(to, from, next)
      }

      // Old system
      /* const playableType = to.params.playableType;
      const playableId = to.params.playableId;

      await BackEndService.sendGetRequest(`${playableType}/${playableId}`)
        .then(() => next())
        .catch(() => openSubscribePage(from.path, undefined, '/home'))) */
    }
    else {
      next();
    }
  })

  // Cancel tour on android
  router.beforeEach((to, from, next) => {
    introJsService.stopTour();
    next();
  });

  router.afterEach((to, from) => {
    if (to.name !== from.name) {
      Vue.$gtag.pageview({ page_path: to.path, page_title: document.title });
      const analyticEvent = {
        title: 'viewed page ' + to.name,
        category: 'Routes',
      };
      analyticEvent.additionalParameters = { ...to.params, ...to.query };

      analyticsController.logAnalyticsEvent(analyticEvent, 'NonGA', userService.user.id !== 0);
    }
  });
};
